// ============================================================
// F12 FITNESS — EDITABLE SITE CONTENT
// Replace placeholder text and image URLs here with real
// branch details, trainer info, membership plans and photos.
// ============================================================

// Official F12 FITNESS logo (user-provided — do not modify)
export const LOGO =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/f35e35c7d2130fcb_WhatsApp%20Image%202026-11-04%20at%2015.19.38.jpeg";

export const IMAGES = {
  about:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/5bb47cf5fb3374af_WhatsApp%20Image%202026-11-03%20at%2012.20.55%20%283%29.jpeg",
};

// Real photographs — F12 FITNESS Chapter 1 (Nalanchira)
export const CH1_PHOTOS = {
  strengthZone:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/6561c2485e02a1bc_WhatsApp%20Image%202026-11-03%20at%2012.20.55.jpeg",
  gymFloorWide:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/591ba0ae055c966e_WhatsApp%20Image%202026-11-03%20at%2012.20.55%20%281%29.jpeg",
  motivationWall:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/85f41f72064ba24e_WhatsApp%20Image%202026-11-03%20at%2012.20.55%20%282%29.jpeg",
  trainingFloor:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/5bb47cf5fb3374af_WhatsApp%20Image%202026-11-03%20at%2012.20.55%20%283%29.jpeg",
  plateLoadedMachines:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/2976f24dd9fa62b2_WhatsApp%20Image%202026-11-03%20at%2012.20.56.jpeg",
  legPressZone:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/82cd077296231e14_WhatsApp%20Image%202026-11-03%20at%2012.20.57.jpeg",
  dumbbellRack:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/074ae4ba4b2c8eb0_WhatsApp%20Image%202026-11-03%20at%2012.20.57%20%281%29.jpeg",
  cableRowZone:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/678a6354d4aa9a03_WhatsApp%20Image%202026-11-03%20at%2012.20.57%20%282%29.jpeg",
};

// Real photographs — F12 FITNESS Chapter 2 (Kudappanakunnu)
export const CH2_PHOTOS = {
  machineFloor:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/b04f8331d2a55fa0_20.webp",
  crossfitGroup:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/12b5de5dfbcdf188_116.webp",
  plateLoadedZone:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/a04195e6a3e56576_25.webp",
  crossfitSession:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_f12-train-hard--17yryal6/artifacts/ed6c970efba5c178_117.webp",
};

// Homepage hero slideshow — all real uploaded gym photos, alternating branches
export const HERO_PHOTOS = [
  CH1_PHOTOS.gymFloorWide,
  CH2_PHOTOS.machineFloor,
  CH1_PHOTOS.strengthZone,
  CH2_PHOTOS.crossfitGroup,
  CH1_PHOTOS.plateLoadedMachines,
  CH2_PHOTOS.plateLoadedZone,
  CH1_PHOTOS.motivationWall,
  CH2_PHOTOS.crossfitSession,
  CH1_PHOTOS.legPressZone,
  CH1_PHOTOS.dumbbellRack,
  CH1_PHOTOS.cableRowZone,
  CH1_PHOTOS.trainingFloor,
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Branches", href: "#branches" },
  { label: "Membership", href: "#membership" },
  { label: "Trainers", href: "#trainers" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const HIGHLIGHTS = [
  {
    icon: "Dumbbell",
    title: "Strength Training",
    text: "Dedicated free-weight and machine zones built for every level of lifter.",
  },
  {
    icon: "UserCheck",
    title: "Professional Training",
    text: "Guidance from experienced coaches who train alongside you.",
  },
  {
    icon: "Building2",
    title: "Modern Fitness Facilities",
    text: "A clean, spacious and fully equipped training environment.",
  },
  {
    icon: "Flame",
    title: "Motivating Environment",
    text: "A high-energy community that pushes you to show up and level up.",
  },
];

export const CONTACT = {
  phoneDisplay: "+91 8089121212",
  phoneHref: "tel:+918089121212",
  email: "f12fitness@gmail.com",
  emailHref: "mailto:f12fitness@gmail.com",
  websiteDisplay: "www.f12fitness.fitness",
  websiteHref: "https://www.f12fitness.fitness",
  socials: [
    { label: "Instagram", href: "#" },
    { label: "Facebook", href: "#" },
    { label: "YouTube", href: "#" },
  ],
};

export const mapsUrl = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const mapsEmbedUrl = (cid, zoom = 17) =>
  `https://maps.google.com/maps?cid=${cid}&z=${zoom}&output=embed`;

// Opening hours — common to all branches
export const OPENING_HOURS = {
  days: "Mon – Sat",
  morning: "5:00 AM – 10:00 AM",
  evening: "4:00 PM – 10:00 PM",
  sunday: "Sunday: Closed",
};

// Membership pricing — confirmed by F12 FITNESS (do not add or modify plans)
export const PRICING = [
  {
    branchId: "chapter-1",
    branchName: "F12 FITNESS CHAPTER 1",
    area: "Nalanchira",
    rows: [
      { label: "Admission Fee", price: "₹1,000" },
      { label: "Monthly Membership", price: "₹800" },
      { label: "Yearly Membership", price: "₹8,000" },
      { label: "Per-Day Membership", price: "₹100" },
    ],
  },
  {
    branchId: "chapter-2",
    branchName: "F12 FITNESS CHAPTER 2",
    area: "Kudappanakunnu",
    rows: [
      { label: "Regular Admission Fee", price: "₹1,000" },
      { label: "Student Admission Fee", price: "₹800" },
      { label: "Monthly Membership", price: "₹899" },
      { label: "Yearly Membership", price: "₹8,999" },
      { label: "Per-Day Membership", price: null },
    ],
  },
];

export const BRANCHES = [
  {
    id: "chapter-1",
    name: "F12 FITNESS CHAPTER 1",
    status: "OPEN",
    image: CH1_PHOTOS.gymFloorWide,
    photoAlt: "F12 FITNESS Chapter 1 — gym floor with strength and cardio equipment",
    address:
      "Main Gate, Nalanchira Post, Near Mar Ivanios Vidya Nagar Main Gate, Thiruvananthapuram, Kerala – 695015",
    mapsLink: "https://maps.app.goo.gl/eTc8BrwknZ7KsEVy6",
    coords: "8.5421819,76.9413786",
    mapCid: "17327927305484969861",
    area: "Nalanchira, Thiruvananthapuram",
  },
  {
    id: "chapter-2",
    name: "F12 FITNESS CHAPTER 2",
    status: "OPEN",
    image: CH2_PHOTOS.machineFloor,
    photoAlt: "F12 FITNESS Chapter 2 — main training floor with benches, racks and machines",
    address:
      "Chitra Nagar, Kudappanakunnu, Peroorkada Post, Thiruvananthapuram, Kerala – 695005",
    mapsLink: "https://maps.app.goo.gl/vnicPoWa5jd6GVMYA",
    coords: "8.5443116,76.9598719",
    mapCid: "7356444380794484362",
    area: "Kudappanakunnu, Thiruvananthapuram",
  },
  {
    id: "chapter-3",
    name: "F12 FITNESS CHAPTER 3",
    status: "OPENING SOON",
    image:
      "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxneW0lMjBiYXJiZWxsJTIwd29ya291dHxlbnwwfHx8fDE3OTM2MjMzNjN8MA&ixlib=rb-4.1.0&q=85",
    photoAlt: "Sample photo — F12 FITNESS Chapter 3 (opening soon)",
    address: null,
  },
];

export const TRAINERS = [];

export const GALLERY = [
  {
    src: CH1_PHOTOS.gymFloorWide,
    alt: "F12 FITNESS Chapter 1 — gym floor with strength machines and dumbbell racks",
  },
  {
    src: CH1_PHOTOS.strengthZone,
    alt: "F12 FITNESS Chapter 1 — strength training zone with power rack and plates",
  },
  {
    src: CH1_PHOTOS.motivationWall,
    alt: "F12 FITNESS Chapter 1 — plate-loaded machines near the motivation wall",
  },
  {
    src: CH1_PHOTOS.trainingFloor,
    alt: "F12 FITNESS Chapter 1 — wide view of the training floor and equipment",
  },
  {
    src: CH1_PHOTOS.plateLoadedMachines,
    alt: "F12 FITNESS Chapter 1 — plate-loaded incline press machines",
  },
  {
    src: CH1_PHOTOS.legPressZone,
    alt: "F12 FITNESS Chapter 1 — leg press and lower-body training zone",
  },
  {
    src: CH1_PHOTOS.dumbbellRack,
    alt: "F12 FITNESS Chapter 1 — dumbbell rack and free-weight area",
  },
  {
    src: CH1_PHOTOS.cableRowZone,
    alt: "F12 FITNESS Chapter 1 — cable machine and rowing stations",
  },
  {
    src: CH2_PHOTOS.machineFloor,
    alt: "F12 FITNESS Chapter 2 — main training floor with benches, racks and machines",
  },
  {
    src: CH2_PHOTOS.plateLoadedZone,
    alt: "F12 FITNESS Chapter 2 — plate-loaded machines and strength zone",
  },
  {
    src: CH2_PHOTOS.crossfitGroup,
    alt: "F12 FITNESS Chapter 2 — group training session in the CrossFit zone",
  },
  {
    src: CH2_PHOTOS.crossfitSession,
    alt: "F12 FITNESS Chapter 2 — members briefing near the CrossFit rig",
  },
  {
    src: "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxneW0lMjBiYXJiZWxsJTIwd29ya291dHxlbnwwfHx8fDE3OTM2MjMzNjN8MA&ixlib=rb-4.1.0&q=85",
    alt: "Sample photo — barbell strength training session",
  },
  {
    src: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxneW0lMjBiYXJiZWxsJTIwd29ya291dHxlbnwwfHx8fDE3OTM2MjMzNjN8MA&ixlib=rb-4.1.0&q=85",
    alt: "Sample photo — athlete lifting weights in the gym",
  },
  {
    src: "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxneW0lMjBlcXVpcG1lbnQlMjBkYXJrfGVufDB8fHx8MTc5MzYyMzM2M3ww&ixlib=rb-4.1.0&q=85",
    alt: "Sample photo — premium gym interior with equipment",
  },
  {
    src: "https://images.unsplash.com/photo-1708011108842-30966718105a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwdHJhaW5lciUyMHBvcnRyYWl0JTIwbXVzY3VsYXIlMjBhdGhsZXRlJTIwZ3ltJTIwd29ya291dHxlbnwwfHx8fDE3OTM2MjMzNTZ8MA&ixlib=rb-4.1.0&q=85",
    alt: "Sample photo — trainer coaching a workout",
  },
  {
    src: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxneW0lMjBiYXJiZWxsJTIwd29ya291dHxlbnwwfHx8fDE3OTM2MjMzNjN8MA&ixlib=rb-4.1.0&q=85",
    alt: "Sample photo — workout with barbell plates",
  },
];
